/* eslint no-console:0 */
// This file is automatically compiled by esbuild, along with any other files
// present in this directory.

// Import jQuery and set it globally FIRST
import './jquery-shim';

// Now Bootstrap can find jQuery
import 'bootstrap3/dist/js/bootstrap';

import Rails from '@rails/ujs';

import "@hotwired/turbo";
Turbo.session.drive = false;
Rails.start();

// Charts for the admin corpus-freshness dashboard.
//
// `chartkick/chart.js` — the subpath, not bare `chartkick` — is what registers Chart.js as the
// adapter. Importing bare `chartkick` compiles cleanly and then renders nothing at runtime, with no
// error, because no adapter was ever registered.
import "chartkick/chart.js";

// require("turbolinks").start()
// require("@rails/activestorage").start()
// require("channels")

import './omni'
import './opens'
import 'chosen-jquery/lib/chosen.jquery'
import 'select2/dist/js/select2'
import 'bootstrap-notify/bootstrap-notify'
import 'timeago'

import Cookies from 'js-cookie'

import {registerAutosaveHooks} from './opens'

window.Turbo = Turbo;

var fn = function () {
    $('time[data-time-ago]').timeago();
    registerAutosaveHooks();


    const $form = $('#advanced_search');
    $form.off('submit').on('submit', function () {
        console.log('submitting form');
        if ($form.data('minimize-search-urls')) {
            console.log('minimizing search urls');
            let minimized = false;
            $form.find(':input').each(function () {
                const $input = $(this);
                if ($input.val() === '' || (Array.isArray($input.val()) && $input.val().length === 0)) {
                    $input.prop('disabled', true);
                    minimized = true;
                }
            });
            if (minimized && $form.find('input[name="min"]').length === 0) {
                $form.append('<input type="hidden" name="min" value="1">');
            }
        }
    });

    $(window).off('pageshow').on('pageshow', function () {
        $('#advanced_search :input').prop('disabled', false);
        $('#advanced_search input[name="min"]').remove();
    });
};
$(fn);
$(document).on('turbolinks:load page:load ajax:success', fn);

window.init = function () {
    const title = $("[name='search[title]']");
    const author = $("[name='search[author]']");
    const summary = $("[name='search[summary]']");
    const saved = $("[name='saved_search_id']");
    const category_required = $("[name='search[category_required][]']");
    const category_optional = $("[name='search[category_optional][]']");
    const category_optional_exclude = $("[name='search[category_optional_exclude]']");
    const character_required = $("[name='search[character_required][]']");
    const character_optional = $("[name='search[character_optional][]']");
    const character_optional_exclude = $("[name='search[character_optional_exclude]']");
    const tags_include_ids = $("[name='search[tags_include_ids][]']");
    const tags_exclude_ids = $("[name='search[tags_exclude_ids][]']");
    const fandoms = $("[name='search[fandoms][]']");
    const crossovers = $("[name='search[crossovers][]']");
    const include_source_fandoms = $("[name='search[include_source_fandoms]']");
    const exclude_crossover_fandoms = $("[name='search[exclude_crossover_fandoms]']");
    const status = $("[name='search[status]']");
    const language = $("[name='search[language]']");
    const rating = $("[name='search[rating][]']");
    const read_filter = $("[name='search[read_filter]']");
    const relationship = $("[name='search[relationships][0][characters][]']");
    const wordcount_lower = $("[name='search[wordcount_lower]']");
    const wordcount_upper = $("[name='search[wordcount_upper]']");
    const favorites_lower = $("[name='search[favorites_lower]']");
    const favorites_upper = $("[name='search[favorites_upper]']");
    const chapters_lower = $("[name='search[chapters_lower]']");
    const chapters_upper = $("[name='search[chapters_upper]']");
    const published_after = $("[name='search[published_after]']");
    const published_before = $("[name='search[published_before]']");
    const updated_after = $("[name='search[updated_after]']");
    const updated_before = $("[name='search[updated_before]']");
    const sort_by = $("[name='search[sort_by]']");
    const order_by = $("[name='search[order_by]']");

    const selectors = {
        title, author, summary, saved,
        category_required, category_optional, category_optional_exclude,
        character_required, character_optional, character_optional_exclude,
        fandoms, crossovers, include_source_fandoms, exclude_crossover_fandoms,
        status, language, rating, read_filter, relationship,
        tags_include_ids, tags_exclude_ids,
        wordcount_lower, wordcount_upper,
        favorites_lower, favorites_upper,
        chapters_lower, chapters_upper,
        published_after, published_before, updated_after, updated_before,
        sort_by, order_by
    };

    saved.chosen({allow_single_deselect: true}).off('change').on('change', (e, p) => navigate(e, p));
    category_required.chosen({max_selected_options: 2});
    category_optional.chosen();
    character_required.chosen({max_selected_options: 4});
    character_optional.chosen();
    tags_include_ids.chosen();
    tags_exclude_ids.chosen();
    fandoms.chosen().off('change').on('change', (e, p) => updateFandom(e, p));
    crossovers.chosen({allow_single_deselect: true}).off('change').on('change', (e, p) => updateCrossover(e, p));
    exclude_crossover_fandoms.click((e, p) => updateCrossover(e, p));
    status.chosen({allow_single_deselect: true});
    language.chosen({allow_single_deselect: true});
    rating.chosen();
    read_filter.chosen();
    sort_by.chosen();
    order_by.chosen();

    $('.character_list').toArray().forEach(elem => {
        $(elem).chosen({max_selected_options: 4});
    });

    $('#clear_fandoms').click(function () {
        fandoms.val([]);
        return fandoms.trigger('chosen:updated');
    });

    $('#clear_crossovers').click(function () {
        crossovers.val([]);
        return crossovers.trigger('chosen:updated');
    });

    $('#clear_character_required').click(function () {
        character_required.val([]);
        return character_required.trigger('chosen:updated');
    });

    $('#clear_character_optional').click(function () {
        character_optional.val([]);
        return character_optional.trigger('chosen:updated');
    });

    $('#advanced_search :checkbox').click(function () {
        return updateCheckboxLabel($(this));
    });

    var updateCheckboxLabel = function (elem) {
        const label_elem = $(`label[for='${elem.attr("name")}']`);
        let label = label_elem.data("type");
        if (elem.is(':checked')) {
            label = `Excluded ${label}`;
        } else {
            label = `Included ${label}`;
        }

        return label_elem.text(label);
    };

    var navigate = function (e, p) {
        const opt = $("option:selected", $("[name='saved_search_id']"))[0];

        if ((opt.value !== null) && (opt.value !== "")) {
            return $.getJSON(`/user/saved_searches/${opt.value}`, function (data) {
                const s = data.search;

                title.val(s.title);
                author.val(s.author);
                summary.val(s.summary);

                fandoms.val(s.fandoms);
                fandoms.trigger('chosen:updated');
                crossovers.val(s.crossovers);
                crossovers.trigger('chosen:updated');
                include_source_fandoms.prop('checked', s.include_source_fandoms);
                exclude_crossover_fandoms.prop('checked', s.exclude_crossover_fandoms);

                s.relationships.forEach(() => clone_relationship_row());

                updateFandom().done(() =>
                    // wait for crossovers change before adding chars
                    (() => {
                        const result = [];
                        for (let prop of ['category', 'character']) {
                            for (let type of ['required', 'optional']) {
                                const propname = prop + "_" + type;
                                selectors[propname].val(s[propname]);
                                selectors[propname].trigger('chosen:updated');
                            }
                            const toggleprop = prop + "_optional_exclude";
                            selectors[toggleprop].prop('checked', s[toggleprop]);
                            result.push(updateCheckboxLabel(selectors[toggleprop]));
                        }

                        $('.shiprow').toArray().forEach((elem) => $(elem).remove());
                        for (let i = 0; i < s.relationships.length; i++) {
                            clone_relationship_row();
                            const characters = $('[id="search[relationships][' + i + '][characters][]"]');
                            characters.val(s.relationships[i]['characters']);
                            characters.trigger('chosen:updated');

                            if (s.relationships[i]['partial'] != null) {
                                $('[id="search[relationships][' + i + '][partial]"]').prop('checked', 'checked');
                            }

                            if (s.relationships[i]['exclude'] != null) {
                                $('[id="search[relationships][' + i + '][exclude]"]').prop('checked', 'checked');
                            }
                        }

                        if (s.relationships.length === 0) {
                            clone_relationship_row();
                        }

                        return result;
                    })()
                );

                return (() => {
                    const result = [];
                    for (let prop of ['wordcount_lower', 'wordcount_upper', 'favorites_lower', 'favorites_upper',
                        'chapters_lower', 'chapters_upper', 'average_words_per_chapter_lower',
                        'published_after', 'published_before', 'updated_after', 'updated_before',
                        'tags_include_ids', 'tags_exclude_ids',
                        'rating', 'read_filter', 'language', 'status', 'sort_by', 'order_by']) {
                        if (s[prop]) {
                            selectors[prop].val(s[prop]);
                            result.push(selectors[prop].trigger('chosen:updated'));
                        }
                    }
                    return result;
                })();
            });
        }
    };

    var updateCrossover = function (e, p) {
        const fandom = $("option:selected", $("[name='search[fandoms][]']"));
        const crossover = $("option:selected", $("[name='search[crossovers][]']"));
        var params = (fandom.map(function (c) {
            return `fandom[]=${$(this).val()}`;
        })).toArray();

        if (exclude_crossover_fandoms.prop('checked')) {
            params = params.concat(`fandom[]=-1`);
            params = params.concat((crossover.map(function (c) {
                return `exclude_fandom[]=${$(this).val()}`;
            })).toArray());
        } else {
            params = params.concat((crossover.map(function (c) {
                return `fandom[]=${$(this).val()}`;
            })).toArray());
        }

        if (params.length > 0) {
            return $.getJSON(`/characters?${params.join('&')}`, function (data) {
                for (let select of $('select.character_list').toArray()) {
                    select = $(select);
                    let existing = select.val();
                    $('option', select).remove();
                    select.append(data.map(v => new Option(v.name, v.id)));
                    select.val(existing);
                    select.trigger('chosen:updated');
                }

                let selectTemplate = $('#shiprow-template select');
                $('option', selectTemplate).remove();
                selectTemplate.append(data.map(v => new Option(v.name, v.id)));

            });
        } else {
            return $.Deferred().resolveWith({});
        }
    };

    var updateFandom = function (e, p, c) {
        let crossover, crossovers_selected, fandom, fandoms_selected, params;
        return updateCrossover(e, p).done(function () {
            },

            (fandom = $("option:selected", $("[name='search[fandoms][]']"))),
            (crossover = $("option:selected", $("[name='search[crossovers][]']"))),

            (fandoms_selected = (fandom.map(function (c) {
                return $(this).val();
            })).toArray()),
            (crossovers_selected = (crossover.map(function (c) {
                return $(this).val();
            })).toArray()),

            (params = (fandom.map(function (c) {
                return `fandom[]=${$(this).val()}`;
            })).toArray()
                .concat((crossover.map(function (c) {
                    return `fandom[]=${$(this).val()}`;
                })).toArray())),

            params.length > 0 ?
                $.getJSON(`/crossovers?${params.join('&')}`, function (data) {
                    const select = $("[name='search[crossovers][]']");
                    const options = select.prop('options');
                    $('option', select).remove();

                    options[options.length] = new Option('', '');
                    $.each(data, (k, v) => options[options.length] = new Option(v.name, v.id));

                    select.val(crossovers_selected);
                    return select.trigger('chosen:updated');
                }) : undefined
        );
    };
};

$(function () {
    $(document).ajaxSend(function (e, xhr, options) {
        var token = $('meta[name="csrf-token"]').attr('content');
        if (token) xhr.setRequestHeader('X-CSRF-Token', token);
    });


    var themeSwitch = document.getElementById('darkmode');
    if (themeSwitch) {
        initTheme(); // on page load, if user has already selected a specific theme -> apply it

        themeSwitch.addEventListener('click', function (event) {
            resetTheme(); // update color theme
        });

        function initTheme() {
            var darkThemeSelected = (localStorage.getItem('themeSwitch') !== null && localStorage.getItem('themeSwitch') === 'dark');
            var body = $('body');

            if (darkThemeSelected) {
                Cookies.set('themeSwitch', 'dark', {expires: 365});
                body.addClass('theme-dark');
            } else {
                Cookies.remove('themeSwitch');
            }
        }

        function resetTheme() {
            var body = $('body');
            if (!body.hasClass('theme-dark')) { // dark theme has been selected
                body.addClass('theme-dark');
                Cookies.set('themeSwitch', 'dark', {expires: 365});
                localStorage.setItem('themeSwitch', 'dark'); // save theme selection
            } else {
                body.removeClass('theme-dark');
                Cookies.remove('themeSwitch');
                localStorage.removeItem('themeSwitch'); // reset theme selection
            }
        }
    }


    $('.report-broken').click(function (e) {
        e.stopImmediatePropagation();
        const story_id = $(this).data('story-id');

        return $.post('/search/report_broken', {'story_id': story_id})
            .done(data => alert('Reported link as broken! Thank you. It may take some time to deindex this story.'));
    });

    // Ship-feedback popover: each `.ship-fb-trigger` (a model-inferred ship) opens a Bootstrap
    // popover with thumbs up/down; "Wrong" reveals an optional comment box before submitting.
    function shipFbPopoverContent() {
        const $trigger = $(this);
        return $(
            '<div class="ship-fb-pop" data-story-id="' + $trigger.attr('data-story-id') + '" ' +
            'data-character-ids="' + $trigger.attr('data-character-ids') + '">' +
                '<div class="btn-group btn-group-xs" role="group">' +
                    '<button type="button" class="btn btn-default ship-fb" data-verdict="up">' +
                        '<i class="fa fa-thumbs-o-up"></i> Correct</button>' +
                    '<button type="button" class="btn btn-default ship-fb" data-verdict="down">' +
                        '<i class="fa fa-thumbs-o-down"></i> Wrong</button>' +
                '</div>' +
                '<div class="ship-fb-comment-wrap" style="display:none;margin-top:6px;">' +
                    '<textarea class="form-control input-sm ship-fb-comment" rows="2" ' +
                        'placeholder="What\'s wrong? (optional)"></textarea>' +
                    '<div style="margin-top:4px;text-align:right;">' +
                        '<button type="button" class="btn btn-primary btn-xs ship-fb-submit">Submit</button>' +
                    '</div>' +
                '</div>' +
                '<div class="ship-fb-thanks text-success small" style="display:none;">Thanks!</div>' +
            '</div>'
        );
    }

    function submitShipFeedback($pop, verdict, comment) {
        const popId = $pop.closest('.popover').attr('id');
        const $trigger = popId ? $('[aria-describedby="' + popId + '"]') : $();

        return $.post('/user/ship_feedback', {
            'story_id': $pop.attr('data-story-id'),
            'character_ids': String($pop.attr('data-character-ids')).split(','),
            'verdict': verdict,
            'comment': comment
        })
            .done(_ => {
                $pop.find('.btn-group, .ship-fb-comment-wrap').hide();
                $pop.find('.ship-fb-thanks').show();
                $trigger.find('i').attr('class', verdict === 'up' ? 'fa fa-margin fa-thumbs-up' : 'fa fa-margin fa-thumbs-down');
                $trigger.addClass(verdict === 'up' ? 'text-success' : 'text-danger');
                setTimeout(() => $trigger.popover('hide'), 900);
            })
            .fail(response => alert(`Failed to record ship feedback: ${response.statusText}`));
    }

    const SHIP_POPOVER_TRIGGERS = '.ship-fb-trigger, .ship-debug-trigger';

    $('.ship-fb-trigger').popover({
        html: true,
        trigger: 'manual',
        placement: 'auto top',
        container: 'body',
        title: 'Is this inferred ship right?',
        content: shipFbPopoverContent
    });

    // Admin-only: clicking an inferred ship opens the inference-debug popover (content lives in the
    // hidden .ship-debug-content holder for the same story id).
    $('.ship-debug-trigger').popover({
        html: true,
        trigger: 'manual',
        placement: 'auto top',
        container: 'body',
        title: 'Inference debug',
        content: function () {
            const storyId = $(this).attr('data-story-id');
            const stored = $('.ship-debug-content[data-story-id="' + storyId + '"]').html();
            // Wrap the stored (backfill-time) view with a config-diff banner and a Refresh control that
            // re-runs inference LIVE with the current runtime config (see /user/ship_debug).
            return $(
                '<div class="ship-debug-pop" data-story-id="' + storyId + '">' +
                    '<div class="ship-debug-banner small" style="display:none;margin-bottom:6px;"></div>' +
                    '<div class="ship-debug-body">' + stored + '</div>' +
                    '<div style="margin-top:6px;text-align:right;">' +
                        '<button type="button" class="btn btn-default btn-xs ship-debug-refresh">' +
                            '<i class="fa fa-refresh"></i> Refresh</button>' +
                    '</div>' +
                '</div>'
            );
        }
    });

    $(SHIP_POPOVER_TRIGGERS).on('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        $(SHIP_POPOVER_TRIGGERS).not(this).popover('hide');
        $(this).popover('toggle');
    });

    // Dismiss any open ship popover on an outside click.
    $(document).on('click', function (e) {
        if ($(e.target).closest(SHIP_POPOVER_TRIGGERS + ', .popover').length === 0) {
            $(SHIP_POPOVER_TRIGGERS).popover('hide');
        }
    });

    $(document).on('click', '.ship-fb-pop .ship-fb', function (e) {
        e.preventDefault();
        const $btn = $(this);
        const $pop = $btn.closest('.ship-fb-pop');
        if ($btn.data('verdict') === 'up') {
            submitShipFeedback($pop, 'up', '');
        } else {
            $pop.find('.ship-fb').removeClass('active');
            $btn.addClass('active');
            $pop.find('.ship-fb-comment-wrap').show();
            $pop.find('.ship-fb-comment').focus();
        }
    });

    $(document).on('click', '.ship-fb-submit', function (e) {
        e.preventDefault();
        const $pop = $(this).closest('.ship-fb-pop');
        submitShipFeedback($pop, 'down', $pop.find('.ship-fb-comment').val() || '');
    });

    function escapeHtml(str) {
        return String(str == null ? '' : str)
            .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
    }

    function shipTauJson(meta) {
        // Canonicalize on SORTED keys — the stored (backfill) meta and the live meta can serialize the τ keys
        // in different orders ({one,both} vs {both,one}); an order-sensitive JSON.stringify would flag an
        // identical config as "changed". Passing a sorted key list makes the comparison value-based.
        const t = (meta && meta.thresholds) || {};
        return JSON.stringify(t, Object.keys(t).sort());
    }

    // Render the LIVE re-inference into the debug popover: swap the stored edge rows for the fresh ones
    // and highlight when the STORED config (backfill time) differs from the CURRENT runtime config.
    function renderShipDebug($pop, data) {
        const meta = data.meta || {};
        const stored = data.stored_meta || {};
        const rows = (data.edges || []).map(e => '<div>' + escapeHtml(e.text) + '</div>').join('');
        const metaLine = 'inferred by ' + escapeHtml(meta.model || 'unknown') + ' τ=' + escapeHtml(shipTauJson(meta));
        $pop.find('.ship-debug-body').html('<div>' + metaLine + '</div>' + rows);

        const changed = (stored.model || null) !== (meta.model || null) || shipTauJson(stored) !== shipTauJson(meta);
        const $banner = $pop.find('.ship-debug-banner');
        if (changed) {
            $banner.html('⚠ stored: ' + escapeHtml(stored.model || 'unknown') + ' τ=' + escapeHtml(shipTauJson(stored)) +
                    ' → current: ' + escapeHtml(meta.model || 'unknown') + ' τ=' + escapeHtml(shipTauJson(meta)))
                .removeClass('text-muted').addClass('text-danger')
                .css('font-weight', 'bold').show();
        } else {
            $banner.html('up to date').removeClass('text-danger').addClass('text-muted')
                .css('font-weight', 'normal').show();
        }
    }

    // Admin-only: re-run ship inference LIVE and re-render the popover with the fresh edges + config diff.
    $(document).on('click', '.ship-debug-refresh', function (e) {
        e.preventDefault();
        const $btn = $(this);
        const $pop = $btn.closest('.ship-debug-pop');
        const $icon = $btn.find('i');
        $btn.prop('disabled', true);
        $icon.addClass('fa-spin');

        $.getJSON('/user/ship_debug', {'story_id': $pop.attr('data-story-id')})
            .done(data => renderShipDebug($pop, data))
            .fail(response => alert(`Failed to refresh ship inference: ${response.statusText}`))
            .always(() => {
                $btn.prop('disabled', false);
                $icon.removeClass('fa-spin');
            });
    });

    $('.read-it-later').click(function (e) {
        e.stopImmediatePropagation();
        const selector = $(this);
        const story_id = selector.data('story-id');
        const origin = selector.data('story-origin');
        const state = selector.data('state');
        let method = 'POST';
        if (state === 'in-queue') {
            method = 'DELETE';
        }

        return $.ajax({
            url: '/user/queue',
            method,
            data: {
                'story_id': story_id,
                'origin': origin,
            }
        })
            .done(_ => {
                if (method === 'POST') {
                    selector.data('state', 'in-queue');
                    return selector.html('<i class="fa fa-minus"></i> Remove from queue');
                } else {
                    selector.data('state', 'out-of-queue');
                    return selector.html('<i class="fa fa-plus"></i> Add to queue');
                }
            })
            .fail(response => {
                if (response.status !== 409) {
                    return alert(`Failed to add/remove story to queue: ${response.statusText}`);
                }
            });
    });

    $('.hide-author').click(function (e) {
        e.stopImmediatePropagation();
        const selector = $(this);
        const author_id = selector.data('author-id');
        const state = selector.data('state');

        if (!confirm('Are you sure you want to hide this author and all of their stories?')) {
            return;
        }

        return $.ajax({
            url: '/user/hidden/author',
            method: 'PUT',
            data: {'author_id': author_id}
        })
            .done(_ => {
                let name = $(`a.author-link[data-author=${author_id}]`).text();

                $.notify({
                    // options
                    message: `Author <strong>${name}</strong> hidden successfully.`
                }, {
                    // settings
                    type: 'success'
                });
            })
            .fail(response => alert(`Failed to hide author: ${response.statusText}`));
    });

    $('.hide-story').click(function (e) {
        e.stopImmediatePropagation();
        const selector = $(this);
        const story_id = selector.data('story-id');
        const state = selector.data('state');

        let method = 'PUT';
        if (state === 'hidden') {
            method = 'DELETE';
        }

        return $.ajax({
            url: '/user/hidden/story',
            method: method,
            data: {'story_id': story_id}
        })
            .done(_ => {
                if (method === 'PUT') {
                    selector.data('state', 'hidden');
                    return selector.html('<i class="fa fa-eye"></i> Undo hide story');
                } else {
                    selector.data('state', 'shown');
                    return selector.html('<i class="fa fa-eye-slash"></i> Hide story');
                }
            })
            .fail(response => {
                if (response.status !== 409) {
                    return alert(`Failed to hide story: ${response.statusText}`);
                }
            });
    });

    $('.unhide-author').click(function (e) {
        e.stopImmediatePropagation();
        const selector = $(this);
        const author_id = selector.data('author-id');
        const state = selector.data('state');

        return $.ajax({
            url: '/user/hidden/author',
            method: 'DELETE',
            data: {'author_id': author_id}
        })
            .done(_ => {
                $(`tr[data-author-id=${author_id}]`).remove()
            })
            .fail(response => alert(`Failed to unhide author: ${response.statusText}`));
    });

    $('.unhide-story').click(function (e) {
        e.stopImmediatePropagation();
        const selector = $(this);
        const story_id = selector.data('story-id');
        const state = selector.data('state');

        return $.ajax({
            url: '/user/hidden/story',
            method: 'DELETE',
            data: {'story_id': story_id}
        })
            .done(_ => {
                $(`tr[data-story-id=${story_id}]`).remove()
            })
            .fail(response => alert(`Failed to unhide story: ${response.statusText}`));
    });

    $('#add_relationships').click(e => {
        e.stopImmediatePropagation();
        clone_relationship_row();
    });

    if ($('#search_controller').data('search') != null) {
        const searchParams = new URLSearchParams(location.search);
        let emptyKeys = [];
        for (const pair of searchParams) {
            if (pair[1] === "") {
                emptyKeys.push(pair[0]);
            }
        }
        for (const key of emptyKeys) {
            searchParams.delete(key);
        }

        window.history.replaceState(null, "", '/search?' + searchParams.toString());
    }

    return $('a.story-link').on('mousedown', function (e) {
        e.stopImmediatePropagation();
        const search = $('#search').data('search');
        const story_id = $(this).data('story-id');
        const origin = $(this).data('story-origin');
        const searchParams = new URLSearchParams(location.search);
        const page = searchParams && searchParams.has('page') ? searchParams.get('page') : 1;
        return $.post('/search/click', {
            'story_id': story_id,
            'search': search,
            'page': page,
            'origin': origin,
        });
    });
});


function clone_relationship_row() {
    let rows = $('.shiprow').toArray();
    let next_index = 0;
    if (rows.length > 0) {
        next_index = Math.max(...rows.map(elem => $(elem).data('ship-index'))) + 1;
    }

    const new_row = $('#shiprow-template').clone();

    // Update ids
    new_row.removeAttr('id');
    const select = new_row.find('select');
    select.attr('name', 'search[relationships][' + next_index + '][characters][]');
    select.attr('id', 'search[relationships][' + next_index + '][characters][]');
    select.addClass('character_list');
    const button = new_row.find('button');
    button.attr('id', 'remove_relationships[' + next_index + ']');
    button.attr('name', 'remove_relationships[' + next_index + ']');
    const checkbox_partial = new_row.find('input[type=checkbox].ship_partial');
    checkbox_partial.attr('id', 'search[relationships][' + next_index + '][partial]');
    checkbox_partial.attr('name', 'search[relationships][' + next_index + '][partial]');
    const checkbox_exclude = new_row.find('input[type=checkbox].ship_exclude');
    checkbox_exclude.attr('id', 'search[relationships][' + next_index + '][exclude]');
    checkbox_exclude.attr('name', 'search[relationships][' + next_index + '][exclude]');

    if (next_index > 0) {
        button.removeAttr('disabled');
    }

    button.click(() => {
        new_row.remove();
    });
    new_row.addClass('shiprow');

    $('#shippingcontainer').append(new_row);
    new_row.data('ship-index', next_index);
    new_row.removeClass('hidden');
    select.chosen({max_selected_options: 4});
}
